export type LeadCancelReason =
  | 'individual'
  | 'not_our_product'
  | 'incorrect_data'
  | 'unreachable'
  | 'duplicate'
  | 'test'
  | 'refused_terms'
  | 'chose_other_company'
  | 'kp_only'
  | 'spam_robot'
  | 'other';

export const LEAD_CANCEL_REASONS: LeadCancelReason[] = [
  'individual',
  'not_our_product',
  'incorrect_data',
  'unreachable',
  'duplicate',
  'test',
  'refused_terms',
  'chose_other_company',
  'kp_only',
  'spam_robot',
  'other',
];

export const LEAD_CANCEL_REASON_LABELS: Record<LeadCancelReason, string> = {
  individual: 'Физлицо',
  not_our_product: 'Не наш продукт',
  incorrect_data: 'Некорректные данные',
  unreachable: 'Не дозвонились',
  duplicate: 'Дубль',
  test: 'Тест',
  refused_terms: 'Отказ / не устроили условия',
  chose_other_company: 'Выбрал другую компанию',
  kp_only: 'Только расчёт КП',
  spam_robot: 'Спам / робот',
  other: 'Другое',
};

export const getLeadCancelReasonLabel = (reason?: string | null): string => {
  if (!reason) return '-';
  if (LEAD_CANCEL_REASONS.includes(reason as LeadCancelReason)) {
    return LEAD_CANCEL_REASON_LABELS[reason as LeadCancelReason];
  }
  return reason;
};
